import React from 'react';
import Avatar from '../atoms/Avatar';
import MessageBubble from '../atoms/MessageBubble';
import './Message.css';

// Simple markdown formatter for info cards
const formatMarkdown = (text) => {
  // Replace **text** with <strong>text</strong>
  return text.replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>');
};

const Message = ({ 
  content, 
  timestamp, 
  isUser = false, 
  avatar, 
  status = 'sent',
  showAvatar = true,
  isInfoCard = false
}) => {
  // If it's an info card, render it differently
  if (isInfoCard) {
    const formattedContent = formatMarkdown(content);
    return (
      <div className="message message-info-card">
        <div className="info-card-bubble">
          <div 
            className="info-card-content"
            dangerouslySetInnerHTML={{ __html: formattedContent }}
          />
        </div>
      </div>
    );
  }

  return (
    <div className={`message ${isUser ? 'message-right' : 'message-left'}`}>
      {!isUser && showAvatar && (
        <div className="message-avatar">
          <Avatar src={avatar} alt="Contact" size="small" />
        </div>
      )}
      <MessageBubble 
        isUser={isUser} 
        timestamp={timestamp}
        status={status}
      >
        {content}
      </MessageBubble>
      {isUser && showAvatar && (
        <div className="message-avatar">
          <Avatar src={avatar} alt="You" size="small" />
        </div>
      )}
    </div>
  );
};

export default Message; 